export default {
  rows: [],
  row: {},
}
